module.exports = __webpack_public_path__ + "2aac949a9879e743f2fcbe631e7a7372.png";